import block from './block.json';

export const cardKeyfactIconThemeAttributes = {
	backgroundColor: '@tokens.variants.default.cardBackgroundColor',
	border: {
		color: '@tokens.variants.default.cardBorderColor',
		width: {
			top: [1, 1],
			right: [1, 1],
			bottom: [1, 1],
			left: [1, 1],
		},
		radius: {
			topLeft: [0, 0],
			topRight: [0, 0],
			bottomRight: [0, 0],
			bottomLeft: [0, 0],
		},
	},
	minWidth: '180px',
	maxWidth: '400px',
	padding: {
		top: [10, 20],
		right: [10, 20],
		bottom: [10, 20],
		left: [10, 20],
	},
	image: {
		alignment: 'center',
		height: [90, 150],
		border: {
			radius: {
				topLeft: [0, 0],
				topRight: [0, 0],
				bottomRight: [0, 0],
				bottomLeft: [0, 0],
			},
		},
	},
	label: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.paragraph',
		textAlignment: 'center',
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const CardKeyfactIconThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: cardKeyfactIconThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
